interface RequestUmbraco {
  culture: string;
  keyProduct: string;
}

interface RequestImgLayout extends RequestUmbraco {
  productType: string;
}

interface RequestAlertLayout extends RequestUmbraco {
  platform: string;
}

export interface HttpTextRequestOptions {
  responseType: 'text';
}

export const RequestImgLayoutDefault: RequestImgLayout = {
  culture: 'culture',
  productType: 'productType',
  keyProduct: 'Professional'
};

export const RequestAlertLayoutDefault: RequestAlertLayout = {
  culture: 'culture',
  platform: 'platform',
  keyProduct: 'Professional'
};

export enum UmbracoEndpoints {
  Base = 'umbraco/api',
  Alert = 'AlertsApi/GetPublishedAlert',
  Banner = 'B2TBannerApi/GetBannerSearchByProductType'
}

export enum UmbracoQueryParams {
  Culture = 'culture=',
  Platform = 'platform=agenciasyempresas',
  ProductType = 'productType=',
  Fields = 'fields=alerts'
}
